<button *ngIf="showRequestTab" (click)="toggleSideMenu()" class="side-menu-toggle">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
<div *ngIf="showRequestTab" class="inner-side-menu">
  <ul class="side-menu">
    <li *ngFor="let item of menuItems" class="side-menu-item">
      <a *appPermissions="item.permissionLink"
         [ngClass]="{'active-link': isActive(item.url), 'disabled': item.disabled}" (click)="navigateSideMenu($event, item.url)"
         [routerLink]="item.url">
        <mat-icon *ngIf="!item.customIcon">{{item.icon}}</mat-icon>
        <mat-icon *ngIf="!!item.customIcon" class="custom" [svgIcon]="item.customIcon"></mat-icon>
        <span class="item-label">{{item.title}}</span>
      </a>

      <ul *ngIf="item?.subItems?.length > 0" class="side-menu-wrap">
        <li *ngFor="let subItem of item.subItems" class="side-menu-item sub-item">
          <a *appPermissions="subItem.permissionLink"
             [ngClass]="{'active-link': isActive(subItem.url), 'disabled': subItem.disabled}"
             [routerLink]="subItem.url">
            <mat-icon *ngIf="!subItem.customIcon">{{subItem.icon}}</mat-icon>
            <mat-icon *ngIf="!!subItem.customIcon" class="custom" [svgIcon]="subItem.customIcon"></mat-icon>
            <span class="item-label">{{subItem.title}}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
